var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title",class:[_vm.alignmentClassName, _vm.primaryStyleClassName]},[_c('h3',{staticClass:"highlight-text"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.subtitle)?_c('p',{staticClass:"descriptive-text"},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }